import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { SIDEBAR_EMPTY_STATE_LOOK_BY_VARIANT } from "./constants";
import type { SidebarEmptyStateProps } from "./types";

export const SidebarEmptyState = ({ variant }: SidebarEmptyStateProps) => {
  const { t } = useTranslation();

  const { Icon, circleClassName, iconClassName, titleKey, hintKey } =
    SIDEBAR_EMPTY_STATE_LOOK_BY_VARIANT[variant];

  return (
    <li className="flex flex-col items-center gap-3 px-6 py-12 text-center">
      <span
        className={clsx(
          "flex h-12 w-12 items-center justify-center rounded-full",
          circleClassName,
        )}
      >
        <Icon size={20} className={iconClassName} />
      </span>
      <span className="flex flex-col gap-1.5">
        <span className="text-sm font-medium text-gray-700">{t(titleKey)}</span>
        <span className="text-xs leading-relaxed text-gray-400">
          {t(hintKey)}
        </span>
      </span>
    </li>
  );
};
